import React from 'react';
import './Stat.less';
import {StatNumber} from 'new-components/elements/stat-number/StatNumber';
import {StatCaption} from 'new-components/elements/stat-caption/StatCaption';

export const Stat = ({number = 0, caption, isClickable, control}) => {
	return (
		<div className={`stat ${isClickable ? 'stat--clickable' : ''}`}>
      <span className="stat__number">
        <StatNumber number={number}/>
      </span>
			<span className="stat__caption">
        <StatCaption text={caption}/>
      </span>
		</div>
	);
};
